import { Container, Text, Group, Stack } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconShieldCheck, IconMail } from '@tabler/icons-react';
import { useTranslation } from '../../contexts/hooks';

export function AppFooter() {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  return (
    <Container size="xl" py="xs">
      <Stack gap="xs" align="center" ta="center">
        <Group gap={isMobile ? "md" : "xl"} justify="center">
          <Group gap="xs">
            <IconShieldCheck size={isMobile ? 14 : 16} color="green" />
            <Text size={isMobile ? "xs" : "sm"} c="dimmed">
              {t('footer.privacy')}
            </Text>
          </Group>
          
          <Group gap="xs">
            <IconMail size={isMobile ? 14 : 16} color="blue" />
            <Text size={isMobile ? "xs" : "sm"} c="dimmed">
              {t('footer.contact')}
            </Text>
          </Group>
        </Group>
      </Stack>
    </Container>
  );
}